import React, { Component } from 'react'
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import { LocationContext } from './context'
import { Link } from 'react-router-dom'

export class MapContainer extends Component {
    static contextType = LocationContext
    constructor(props) {
        super(props);
        this.state = { address: '', LatLng: {}, title: '' };
    }
    componentDidMount() {
        const { state } = this.context
        if (state !== undefined && state.location.length !== 0)
            this.setState({ LatLng: state.location[0].LatLng, title: state.location[0].title })
    }
    handleChange = address => {
        this.setState({ address });
    };

    handleSelect = address => {
        this.setState({ address });
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => { this.setState({ LatLng: latLng }) });
    };
    render() {
        const { state } = this.context

        return (
            <>
                <Map google={this.props.google} zoom={8} center={this.state.LatLng}>
                    <Marker onClick={this.onMarkerClick}
                        name={this.state.title}
                        position={this.state.LatLng} />
                    {state.location.map((item, index) =>
                        <Marker onClick={this.onMarkerClick}
                            key={index}
                            name={item.title}
                            position={item.LatLng} />
                    )
                    }
                    {/* <InfoWindow onClose={this.onInfoWindowClose}>
                    <div>
                        <h1>{this.state.selectedPlace.name}</h1>
                    </div>
                </InfoWindow> */}
                </Map>
                <div style={{ position: 'absolute', top: 75, width: '100%', textAlign: 'center' }}>
                    <PlacesAutocomplete
                        value={this.state.address}
                        onChange={this.handleChange}
                        onSelect={this.handleSelect}
                    >
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                                <input
                                    style={{
                                        background: '#fff',
                                        color: '#000',
                                        padding: '15px 20px',
                                        borderRadius: '50px',
                                        border: 'none',
                                        fontSize: 20,
                                        outline: 'none',
                                        maxWidth: "300px"
                                    }}
                                    value={this.state.address}
                                    type='text'
                                    {...getInputProps({
                                        placeholder: 'Search Places ...',
                                        className: 'location-search-input',
                                    })}
                                />
                                <div className="autocomplete-dropdown-container">
                                    {loading && <div>Loading...</div>}
                                    {suggestions.map(suggestion => {
                                        const className = suggestion.active
                                            ? 'suggestion-item--active'
                                            : 'suggestion-item';
                                        // inline style for demonstration purpose
                                        const style = suggestion.active
                                            ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                            : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                        return (
                                            <div
                                                {...getSuggestionItemProps(suggestion, {
                                                    className,
                                                    style,
                                                })}
                                            >
                                                <span>{suggestion.description}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </PlacesAutocomplete>

                </div>
                <div style={{ position: 'absolute', bottom: 10, width: '100%', textAlign: 'center' }}>
                    <Link to='/post'>
                        <button style={{
                            background: '#d50320',
                            color: '#fff',
                            padding: '15px 20px',
                            borderRadius: '50px',
                            border: 'none',
                            fontSize: 20,
                            outline: 'none'
                        }}>
                            POST YOUR AD
                    </button>
                    </Link>

                </div>
            </>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: ('AIzaSyCVV7OEgO1ROKUXCJxa2NkqlWwV50J_nCQ')
})(MapContainer)